import { useState, useEffect, createContext, useContext } from "react";

import { changePassword, deleteUserAccount, handleAuthenticate, handleAuthorize, handleCreateAccount, handleUpdate, recoverPassword, sendResetMail, userLogout } from "./authentication.services";
import { getToken } from "../../_helpers/get-token";
import { uploadImageToServer, deleteImageFromServer } from "../products/product.services";

const AuthenticationContext = createContext();

export const AuthenticationContextProvider = ({ children }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState();
    const [account, setAccount] = useState();
    const [token, setToken] = useState(null);

    const uploadAvatar = async (data) => {
        try {
            setIsLoading(true);
            const response = await uploadImageToServer(data);
            const imageUrl = await response.json();
            //console.log(imageUrl);
            setIsLoading(false);
            return imageUrl;
        } catch (error) {
            console.log({ error });
            return({error});
        } finally {
            setIsLoading(false);
        } 
    }

    const removeAvatar = async (uri) => {
        try {
            const response = await deleteImageFromServer(uri);
            const resp = await response.json();
            return resp;
        } catch (error) {
            console.log({ error });
            return({error});
        }
    }

    const registerAccount = async (accountData) => {
        setIsLoading(true);
        try {
            const response = await handleCreateAccount(accountData);
            const res = await response.json();
            setIsLoading(false);
            return res;
        } catch (error) {
            console.log({ error });
            return { error };
        } finally {
            setIsLoading(false);
        }
    }

    //login to user account
    const accountLogin = async (data) => {
        try {
            setIsLoading(true);
            const response = await handleAuthenticate(data);
            const res = await response.json();
            if (res?.error) {
                setIsAuthenticated(false);
                return res;
            }
            setIsAuthenticated(true);
            setAccount(res?.account);
            setToken(res?.token);
            return res;
        } catch (error) {
            console.log({ error });
            setIsLoading(false);
            return { error };
        } finally {
            setIsLoading(false);
        }
    }

    //authorizeaccount
    const authorizeAccount = async (token) => {
        try {
            const response = await handleAuthorize(token);
            const res = await response.json();
            return res;
        } catch (error) {
            return { error };
        }
    }

    /** user logout */
    const logoutUser = async (token) => {
        try {
            setIsLoading(true);
            const response = await userLogout(token);
            const resp = await response.json();
            return resp;
        } catch (error) {
            console.log({ error });
        } finally {
            setIsLoading(false);
        }
    }

    /** delete account */
    const deleteUser = async (token) => {
        try {
            setIsLoading(true);
            const response = await deleteUserAccount(token);
            const resp = await response.json();
            setIsLoading(false);
            return resp;
        } catch (error) {
            console.log({ error });
        } finally {
            setIsLoading(false);
        }
    }

    //send reset email
    const sendResetEmail = async (email) => {
        try {
            setIsLoading(true);
            const response = await sendResetMail(email);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({ error });
        } finally {
            setIsLoading(false);
        }
    }

    //recover passoword
    const passwordRecovery = async (data, resetToken) => {
        try {
            setIsLoading(true);
            const response = await recoverPassword(data, resetToken);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({ error });
        } finally {
            setIsLoading(false);
        }
    }

    //change password
    const passwordChange = async (data, token) => {
        try {
            setIsLoading(true);
            const response = await changePassword(data, token);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({ error });
        } finally {
            setIsLoading(false);
        }
    }

    const updateAccount = async (data, token) => {
        try {
            setIsLoading(true);
            const response = await handleUpdate(data, token);
            const res = await response.json();
            return res;
        } catch (error) {
            console.log({ error });
            return ({ error });
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        (async () => {
            try {
                const tk = await getToken
                //console.log({token});
                if (!tk) {
                    setIsAuthenticated(false);
                    return;
                }
                const resp = await authorizeAccount(tk);
                //console.log(resp);
                if (resp?.error) {
                    setIsAuthenticated(false);
                    return;
                }
                setAccount(resp);
                setToken(tk);
                setIsAuthenticated(true);
            } catch (error) {
                setIsAuthenticated(false);
                console.log({ error });
            }

        })();
    }, [isAuthenticated])

    return (
        <AuthenticationContext.Provider
            value={{
                account,
                isAuthenticated,
                isLoading,
                token,
                registerAccount,
                accountLogin,
                authorizeAccount,
                logoutUser,
                deleteUser,
                sendResetEmail,
                passwordRecovery,
                passwordChange,
                updateAccount,
                uploadAvatar,
                removeAvatar
            }}
        >
            {children}
        </AuthenticationContext.Provider>
    )
}

export const useAuthentication = () => useContext(AuthenticationContext);